<template>
<div>

  <div class="main">
    <v-row>

    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        type="file"
        multiple
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".pdf,.jpg,.jpeg,.png"
      />

      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Arrastra tus imagenes aqui</div>
        <div v-else>Arrastra tus imagenes aqui o <u>haz click aquí</u> para subirlas.</div>
      </label>
    </div>
    </v-row>
  </div>
    <v-row>
      <v-col cols=2 v-for="(file) in files" :key="file">
        <v-img :src="fGetImageFile(file)"></v-img>
      </v-col>
    </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      files: [],
    };
  },
  methods: {
    fGetImageFile(file){
      return URL.createObjectURL(file)
    },

    onChange() {
      this.files = [...this.$refs.file.files];
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
  },
  watch:{
    files(){
      this.$emit('uploadedFiles', this.files)
    }
  }
};
</script>
<style scoped src="@/assets/dropfile.css"></style>